/**
 * Tiny decoupled bridge so the axios layer can signal "the session is no longer
 * valid" (a 401 from an authed request) without importing the Redux store
 * (which would create an import cycle). App registers a handler that clears the
 * session; the response interceptor calls `triggerUnauthorized()`.
 */
type UnauthorizedHandler = () => void;

let handler: UnauthorizedHandler | null = null;

export const setUnauthorizedHandler = (h: UnauthorizedHandler | null): void => {
  handler = h;
};

export const triggerUnauthorized = (): void => {
  if (handler) handler();
};
